import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import invariant from 'invariant';

export interface IShortcodeSettings {
	cat?: string;
	filters?: boolean;
	expired?: boolean;
	view?: string;
	venue?: string;
	tag?: string;
	countries?: string;
	states?: string;
	cities?: string;

	//individual filters
	searchFilter?: boolean;
	locationFilter?: boolean;
	venueFilter?: boolean;
	categoryFilter?: boolean;
	tagFilter?: boolean;
}
interface IShortcodeSettingsContext {
	settings: IShortcodeSettings;
}

const ShortcodeSettingsContext = createContext<IShortcodeSettingsContext | undefined>(undefined);

export const ShortcodeSettingsProvider: React.FC<{ children: React.ReactNode; value: IShortcodeSettings }> = ({
	children,
	value,
}) => {
	const [settings, setSettings] = useState<IShortcodeSettings>(value);

	useEffect(() => {
		setSettings({ ...value });
	}, [value]);

	const contextValue = useMemo(() => ({ settings }), [settings]);

	return <ShortcodeSettingsContext.Provider value={contextValue}>{children}</ShortcodeSettingsContext.Provider>;
};

export const useShortcodeSettings = (): IShortcodeSettingsContext => {
	const context = useContext(ShortcodeSettingsContext);

	invariant(context, 'useShortcodeSettings must be used within a ShortcodeSettingsProvider');

	return context;
};
